import { useEffect } from 'react';
import { captureMessage } from '@sentry/react';
import { CourseCard } from '@/components/partial/course-card';
import { Carousel } from '@/components/shared/carousel';
import { useRecommendationChannel } from '@/context/channels/recommendation';
import { useRecommendationProfile } from '@/context/recommendation-profile';
import {
  RecommendationProcessingStatus,
  useCourseRecommendations,
} from '@/data/recommendation/course-recommendations';
import { ProfileStepIds } from '@/models/recommendation';
import { CardsSkeleton } from '@/packages/home/components/skeleton';

export const Recommendations = () => {
  const { profile } = useRecommendationProfile();
  const { subscribeRecommendation } = useRecommendationChannel();
  const { recommendations, error, isFetching, processingStatus, id } =
    useCourseRecommendations({ profileId: profile?.id });

  const isProcessing =
    processingStatus &&
    processingStatus !== RecommendationProcessingStatus.Completed;

  const isErrorState =
    processingStatus === RecommendationProcessingStatus.Failed || id === null;

  // Usa isFetching porque, ao atualizar o perfil, a API pode retornar os cursos atualizados diretamente sem passar pelo status "processing"
  const showSkeleton = isFetching || isProcessing || isErrorState;
  const showContent = !showSkeleton && recommendations?.length && !error;
  const isPresentationFinished =
    profile?.current_step === ProfileStepIds.PresentationFinished;

  useEffect(() => {
    if (isProcessing && isPresentationFinished) subscribeRecommendation();
  }, [isProcessing, subscribeRecommendation, isPresentationFinished]);

  useEffect(() => {
    if (!isErrorState) return;
    console.log({ isErrorState });

    captureMessage('Recommendation stuck', {
      level: 'error',
      extra: { processingStatus, profileId: profile?.id },
    });
  }, [isErrorState, processingStatus, profile?.id]);

  if (showSkeleton) return <CardsSkeleton withTextSkeleton={false} />;

  if (!showContent) return null;

  const slidesComponents = recommendations.map((slide, idx) => {
    return (
      <CourseCard
        data={slide}
        key={slide.id + idx}
        urlParams={{ utm_campaign: 'recommendation_carousel' }}
      />
    );
  });

  return <Carousel slidesComponents={slidesComponents} />;
};
